<template>
  <v-card flat min-height="100">
    <v-row class="mx-auto fill-height" no-gutters justify="start">

      <v-col cols="12" md="4" class="px-md-2">
        <div class="d-inline-flex">
          <v-checkbox v-show="isFilter" class="mt-n1 align-center" dense
                      @change="filterValueChanged($event, 'type')"
                      hide-details v-model="filters.type"></v-checkbox>
          <v-select v-model="lightConditionsEntry.type" :items="typeList" style="max-width: 200px"
                    :disabled="isFilter && !filters.type"
                    :label="$vuetify.lang.t(`$vuetify.criticalDataset.${CriticalDatasetLabels.LIGHT_CONDITIONS}.type`)">
            <template v-slot:selection="data">
              {{ $vuetify.lang.t(`$vuetify.criticalDataset.enums.LightConditionsType.${data.item}`) }}
            </template>
            <template v-slot:item="data">
              {{ $vuetify.lang.t(`$vuetify.criticalDataset.enums.LightConditionsType.${data.item}`) }}
            </template>
          </v-select>
        </div>
      </v-col>

      <v-col cols="12" md="4" v-show="!isNight" class="px-md-2">
        <div class="d-inline-flex">
          <v-checkbox v-show="isFilter" class="mt-n1 align-center" dense
                      @change="filterValueChanged($event, 'sun')"
                      hide-details v-model="filters.sun"></v-checkbox>
          <v-select v-model="lightConditionsEntry.sun" :items="sunList" style="max-width: 200px"
                    :disabled="isFilter && !filters.sun"
                    :label="$vuetify.lang.t(`$vuetify.criticalDataset.${CriticalDatasetLabels.LIGHT_CONDITIONS}.sun`)">
            <template v-slot:selection="data">
              {{ $vuetify.lang.t(`$vuetify.criticalDataset.enums.LightConditionsSun.${data.item}`) }}
            </template>
            <template v-slot:item="data">
              {{ $vuetify.lang.t(`$vuetify.criticalDataset.enums.LightConditionsSun.${data.item}`) }}
            </template>
          </v-select>
        </div>
      </v-col>

      <v-col cols="12" md="4" class="px-md-2">
        <div class="d-inline-flex">
          <v-checkbox v-show="isFilter" class="mt-n1 align-end" dense
                      @change="filterValueChanged($event, 'rain')"
                      hide-details v-model="filters.rain"></v-checkbox>
          <v-switch :label="$vuetify.lang.t(`$vuetify.criticalDataset.${CriticalDatasetLabels.LIGHT_CONDITIONS}.rain`)"
                    :disabled="isFilter && !filters.rain"
                    v-model="lightConditionsEntry.rain" hide-details></v-switch>
        </div>

      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { LightConditionsEntry } from '../../../models/criticalDataset/LightConditionsEntry'
import { CriticalDatasetLabels, LightConditionsSun, LightConditionsType } from '../../../enum'
import criticalDatasetMixin from '../../../mixins/criticalDatasetMixin'

export default {
  name: 'criticalDatasetLightConditions',
  mixins: [criticalDatasetMixin(LightConditionsEntry, 'lightConditions')],
  props: {
    lightConditionsEntry: LightConditionsEntry
  },
  computed: {
    isNight () {
      return this.lightConditionsEntry.type === LightConditionsType.NIGHT_TIME
    }
  },
  data: () => ({
    typeList: Object.values(LightConditionsType),
    sunList: Object.values(LightConditionsSun)
  }),
  created () {
    this['CriticalDatasetLabels'] = CriticalDatasetLabels
    this['LightConditionsSun'] = LightConditionsSun
  }
}
</script>

<style scoped>

</style>
